var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{class:['toast', _vm.type]},[(_vm.loading)?_c('div',{staticClass:"loading-spinner"}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.message))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }